export const ROUTE = {
  START: 'start-ancillary-quote',
  VISION_RESULT: 'vision-result',
  DENTAL_RESULT: 'dental-result',
  PRODUCER_EMAIL_ENTRY: 'producer-email-entry',
  INDEX: 'index.html',
} as const

export type ROUTE = (typeof ROUTE)[keyof typeof ROUTE]
